<template lang="pug">
  .container-payment.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/payment") 收款账户管理
          el-breadcrumb-item 收款账户详情
    cBox
      c-header-small
        template(slot="left") 账户信息
        el-button(type="primary", @click="showEditAccount", slot="right") 修改账户名称
      el-form(:model="accountDetail",label-position="right",label-width="150px")
        el-row(:gutter="10")
          el-col(:span="8")
            el-form-item(label="收款账户名称") {{ accountDetail.desc }}
          el-col(:span="8")
            el-form-item(label="收款账户 ID") {{ accountDetail.account_id }}
          el-col(:span="8")
            el-form-item(label="结算方式") {{ accountDetail.settle_type | settle_type_list }}
    hr
    
    cBox(v-if="accountDetail.settle_type === 1", v-loading="editBinding.loading", :element-loading-fullscreen="false")
      c-header-small
        template(slot="left") 绑定结算账户
        el-button(type="primary", @click="showEditBinding", slot="right")
          template(v-if="settleDetail.settle_account") 更改
          template(v-else) 绑定
        //- div {{accountDetail}}
      .align-center(v-if="!settleDetail.settle_account")
        .display-block 当前收款账号尚未绑定结算账号
      el-form(:model="settleDetail", label-position="right", label-width="150px", v-else)
        //- el-row(:gutter="10")
        //-   el-col(:span="12")
        //-     el-form-item(label="结算账号") {{ settleDetail.account_name }}
        //-     el-form-item(label="") {{ settleDetail.deposit_bank }}
        //-   el-col(:span="12")
        //-     el-form-item(label="开户姓名或公司名称") {{ settleDetail.deposit_name }}
        //-     el-form-item(label="银行卡号") {{ settleDetail.bank_account }}
        el-table(:data="[settleDetail]", fit, v-loading="listLoading")
          el-table-column(label="账户类型", min-width="100", show-tooltip-when-overflow,v-slot="{ row }") {{ row.settle_type == 1 ? '银行账号' : ' 钱包账号' }}
          el-table-column(property="deposit_name", label="开户名", min-width="150", show-tooltip-when-overflow)
          el-table-column(property="deposit_bank", label="开户行/钱包名称", min-width="150", show-tooltip-when-overflow)
          el-table-column(property="bank_account", label="银行卡号/钱包ID", min-width="175", show-tooltip-when-overflow)
          el-table-column(property="binding_time", label="绑定时间", min-width="175", show-tooltip-when-overflow)
          el-table-column(label="账号状态", min-width="175", show-tooltip-when-overflow,v-slot="{ row }") {{ row.status == 2 ? '禁用' : ' 正常' }}
    cBox(v-if="accountDetail.settle_type === 2")
      c-header-small
        template(slot="left") 微众钱包
        template(slot="right") 
          el-button(type="primary", @click="showCreateWallet", v-if="!walletConfig.status") 添加钱包
          el-button(type="primary", @click="toWalletVerify(account_id)", v-else-if="walletConfig.status === 1") 验证
          el-button(type="primary", @click="toWalletDetail(account_id)", v-else) 详情
          el-button(@click="getWalletConfig") 刷新
      el-form(:model="accountDetail",label-position="right",label-width="150px")
        el-form-item(label="钱包状态", v-if="!walletConfig.status") 未绑定
        el-form-item(label="钱包状态", v-else-if="walletConfig.status === 1") 待验证
        el-row(:gutter="10", v-else)
          el-col(:span="12")
            el-form-item(label="钱包状态") 已验证
          el-col(:span="12")
            el-form-item(label="账户余额") {{ walletConfig.balance }}

    cBox(v-if="accountDetail.settle_type === 3")
      c-header-small
        template(slot="left") 富力钱包
        el-card.settle-card(shadow="hover")
          .settle-card-title(slot="header") 富力钱包
          .settle-card-content 账号: {{wallet.id || ''}}
          hr
          .settle-card-options
            .settle-card-status
              span {{accountDetail.status === 0 ? '待开通' :'已开通' }}
            .settle-card-detail(@click="showWalletDetail()")
              span 详情
              fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
      
    el-dialog(title="修改账户名称", :visible.sync="editAccount.show")
      el-form(:model="editAccount", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="收款账户名称", required)
          el-input(v-model="editAccount.desc")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEditAccount()") 保存
        el-button(@click="hideEditAccount()") 取消

    el-dialog(title="绑定结算账户", :visible.sync="editBinding.show", top="5%", width="80%")
      el-table(:data="editBinding.accountList", fit, v-loading="editBinding.loading", :element-loading-fullscreen="false")
        el-table-column(property="deposit_name", label="开户姓名或公司名称", min-width="200", show-tooltip-when-overflow)
        el-table-column(property="deposit_bank", label="", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="bank_account", label="银行卡号", min-width="200", show-tooltip-when-overflow)
        el-table-column(property="create_time", label="添加时间", min-width="175", show-tooltip-when-overflow)
        el-table-column(label="状态", width="100", v-slot="{ row }") {{ row.status | acccountStatus }}
        el-table-column(label="绑定状态", width="100", v-slot="{ row }") {{ row.bind_status | acccountBindStatus }}
        el-table-column(label="操作", width="100", v-if="iface.toBind || iface.toUnbind", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="toEditBinding(row.id)", v-if="row.bind_status === 1 && iface.toBind") 绑定
            el-button(@click="toEditUnbinding(row.id)", v-if="row.bind_status === 2 && iface.toUnbind") 解绑
      .dialog-footer(slot="footer")
        el-button(@click="toSettleList()") 结算账户管理
        el-button(@click="hideEditBinding()") 关闭

    el-dialog(title="开通微众钱包", :visible.sync="createWallet.show")
      el-form(:model="createWallet", label-position="right", label-width="125px")
        el-form-item(label="收款账户名称") {{ createWallet.source.desc }}
        el-form-item(label="收款账户 ID") {{ createWallet.source.account_id }}
        el-form-item(label="说明") 请填写用于富力钱包提现的银行卡信息，可以与收款账户绑定的银行卡信息一致。
        el-form-item(label="开户名", required)
          el-input(v-model="createWallet.source.deposit_name")
        el-form-item(label="", required)
          el-input(v-model="createWallet.source.deposit_bank")
        el-form-item(label="银行账号", required)
          el-input(v-model="createWallet.source.bank_account")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreateWallet()") 保存
        el-button(@click="hideCreateWallet()") 取消

    verifier(ref="bindAccount", @success_verify="toBind", scene="BIND_BANKCARD", opt="MCH_VERIFY")
    verifier(ref="unbindAccount", @success_verify="toUnbind", scene="BIND_BANKCARD", opt="MCH_VERIFY")
</template>

<script>
export default {
  data() {
    return {
      accountDetail: {},
      editAccount: {
        show: false,
        desc: null
      },

      editBinding: {
        show: false,
        accountList: [],
        settle_account: null,
        loading: false
      },

      walletConfig: {},
      createWallet: {
        show: false,
        source: {
          account_id: null,
          desc: null,
          deposit_name: null,
          deposit_bank: null,
          bank_account: null
        }
      },

      bindingAccountId: null,

      settleDetail: {},

      showWallet: false,
      wallet: {}
    };
  },
  computed: {
    settle_type() {
      return this.$store.getters.userInfo.settle_type;
    },
    account_id() {
      return this.$route.params.account_id;
    },
    iface() {
      const privileges = this.$store.getters.privileges;
      let iface = {};
      privileges.forEach(({ url }) => {
        switch (url) {
          case "/mch_web/v1/settle/add_account":
            iface.toAddAccount = true;
            break;
          case "/mch_web/v1/settle/edit_account":
            iface.toEditAccount = true;
            break;
          case "/mch_web/v1/settle/cfg":
            iface.toBind = true;
            break;
          case "/mch_web/v1/settle/discfg":
            iface.toUnbind = true;
            break;
        }
      });
      return iface;
    }
  },
  methods: {
    toSettleList() {
      this.hideEditBinding();
      this.$router.push("/settle");
    },
    showEditAccount() {
      this.editAccount = {
        show: true,
        desc: this.accountDetail.desc
      };
    },
    hideEditAccount() {
      this.editAccount = {
        show: false,
        desc: null
      };
    },
    saveEditAccount() {
      if (!this.editAccount.desc) {
        this.$message({
          type: "warning",
          message: `请输入账户名称`
        });
        return false;
      }

      const params = {
        account_id: this.account_id,
        desc: this.editAccount.desc
      };
      this.$store
        .dispatch("EDIT_ACCOUNT_DETAIL", params)
        .then(() => {
          this.getAccountDetail();
          this.hideEditAccount();
          this.$message({
            type: "success",
            message: "修改成功"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `修改失败。${code}：${msg}`
          });
        });
    },

    showEditBinding() {
      this.editBinding = {
        show: true,
        accountList: [],
        settle_account: null,
        loading: false
      };
      this.getSettleAccountList();
    },
    hideEditBinding() {
      this.editBinding = {
        show: false,
        accountList: [],
        settle_account: null,
        loading: false
      };
    },
    getSettleAccountList() {
      this.editBinding.loading = true;
      this.$store
        .dispatch("GET_SETTLE_ACCOUNT_LIST_BY_PAYMENT_ACCOUNT", {
          offset: 0,
          limit: 50,
          stat: true,
          account_id: this.account_id
        })
        .then(data => {
          this.editBinding.accountList = data.list;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.editBinding.loading = false;
        });
    },
    toEditBinding(settle_account) {
      this.$confirm("是否确定把此收款账户绑定到该结算账户？", {
        type: "danger"
      })
        .then(() => {
          this.editBinding.settle_account = settle_account;
          this.$refs.bindAccount.init();
        })
        .catch(() => {});
    },
    toEditUnbinding(settle_account) {
      this.$confirm("是否确定解除此收款账户与该结算账户之间的绑定？", {
        type: "danger"
      })
        .then(() => {
          this.editBinding.settle_account = settle_account;
          this.$refs.unbindAccount.init();
        })
        .catch(() => {});
    },

    toBind(biz_ticket) {
      this.$store
        .dispatch("BIND_ACCOUNT", {
          account_id: this.account_id,
          settle_account: this.editBinding.settle_account,
          biz_ticket,
          type: 1
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "绑定成功"
          });

          this.getSettleAccountList();
          this.getSettleDetail();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `绑定失败：${code}：${msg}`
          });
        });
    },
    toUnbind(biz_ticket) {
      this.$store
        .dispatch("UNBIND_ACCOUNT", {
          account_id: this.account_id,
          settle_account: this.editBinding.settle_account,
          biz_ticket
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "解绑成功"
          });

          this.getSettleAccountList();
          this.getSettleDetail();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `解绑失败：${code}：${msg}`
          });
        });
    },

    showCreateWallet() {
      this.createWallet = {
        show: true,
        source: {
          account_id: this.account_id,
          desc: this.accountDetail.desc,
          deposit_name: null,
          deposit_bank: null,
          bank_account: null
        }
      };
    },
    hideCreateWallet() {
      this.createWallet = {
        show: false,
        source: {
          account_id: null,
          desc: null,
          deposit_name: null,
          deposit_bank: null,
          bank_account: null
        }
      };
    },
    saveCreateWallet() {
      if (
        !this.createWallet.source.deposit_name ||
        !this.createWallet.source.deposit_bank ||
        !this.createWallet.source.bank_account
      ) {
        this.$message({
          type: "warning",
          message: `请输入开户名、和银行账号`
        });
        return false;
      }

      this.$store
        .dispatch("CREATE_WALLET", this.createWallet.source)
        .then(() => {
          this.getWalletConfig();
          this.hideCreateWallet();

          this.$message({
            type: "success",
            message: "富力钱包添加成功，请完成验证操作"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `富力钱包添加失败。${code}：${msg}`
          });
        });
    },

    changeAccountStatus({ id, status }) {
      this.$store
        .dispatch("UPDATE_SETTLE_ACCOUNT_STATUS", { id, status })
        .then(() => {
          this.$message({
            type: "success",
            message: "状态修改成功"
          });

          this.refresh();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `状态修改失败：${code}：${msg}`
          });
          this.refresh();
        });
    },

    getAccountDetail() {
      const account_id = this.account_id;
      return this.$store
        .dispatch("GET_ACCOUNT_DETAIL", account_id)
        .then(data => {
          this.accountDetail = data;
          if (data.settle_type === 1) {
            this.getSettleDetail();
          } else if (data.settle_type === 2) {
            this.getWalletConfig();
          } else if (data.settle_type === 3) {
            this.getWalletDetail();
          }
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取账户信息失败。${code}：${msg}`
          });
        });
    },

    toWalletVerify(account_id) {
      this.$router.push(`/payment/${account_id}/verify`);
    },
    toWalletDetail(account_id) {
      this.$router.push(`/payment/${account_id}/detail`);
    },

    getWalletConfig() {
      const account_id = this.account_id;

      return this.$store
        .dispatch("GET_WALLET_CONFIG", account_id)
        .then(data => {
          this.walletConfig = data;
          return data;
        })
        .catch(({ code, msg }) => {
          if (code !== 45109) {
            this.$message({
              type: "error",
              message: `获取结算钱包信息失败。${code}：${msg}`
            });
          }
        });
    },
    getSettleDetail() {
      const account_id = this.account_id;
      this.editBinding.loading = true;
      return this.$store
        .dispatch("GET_SETTLE_CONFIG_DETAIL", account_id)
        .then(data => {
          this.settleDetail = data;
          return data;
        })
        .catch(({ code, msg }) => {
          if (code !== 45104) {
            this.$message({
              type: "error",
              message: `获取结算绑定账号信息失败。${code}：${msg}`
            });
          } else {
            this.settleDetail = {};
          }
        })
        .finally(() => {
          this.editBinding.loading = false;
        });
    },
    getWalletDetail() {
      console.log(123123);
      this.$store
        .dispatch("GET_WALLET_INFO", {
          settle_id: this.$route.params.settle_account
        })
        .then(res => {
          this.wallet = res.wallet;
          console.log(res);
        })
        .catch(({ code, msg }) => {
          if (code !== 45104) {
            this.$message({
              type: "error",
              message: `获取钱包信息失败。${code}：${msg}`
            });
          }
        });
    },

    init() {
      this.getAccountDetail();
    },

    // 点击富力钱包
    showWalletDetail() {
      // 需要先查一下当前的钱包状态
      this.$router.push(
        `/wallet/detail/${this.wallet.id}/${this.$route.params.settle_account}`
      );
    }
  },
  mounted() {
    if (!this.account_id) {
      this.$router.replace("/paymentList");
    } else {
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
@import (reference) "../../assets/general";

.settle-card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.settle-card {
  box-sizing: border-box;
  width: 23%;
  margin: 10px 1%;

  .el-card__header {
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    word-break: break-all;
    background: rgba(38, 90, 160, 1);
    color: #fff;
  }
  .el-card__body {
    padding: 10px;
    font-size: 12px;
  }
}

.settle-card-options {
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg + span,
  span + svg {
    margin-left: 0.5em;
  }
}
.settle-card-copy,
.settle-card-detail {
  cursor: pointer;
}
</style>
